module.exports = __webpack_public_path__ + "media/images/costumes/top/logo/logo-5-e0523552e302c95c4baeea3bc09e41f4.png";